
import { computed, defineComponent, reactive } from 'vue';
import { IOptionString } from '@/core/models/AntDesign/IOption';
import { useTelaBase } from '@/core/composables/TelaBase';
import ServicoCenarioFiscal from '@/servicos/Cadastros/Tributacoes/ServicoCenarioFiscal';

export default defineComponent({
  name: 'SelecionarCstIpi',
  props: {
    varios: {
      type: Boolean,
      default: false,
    },
    codigoSelecionado: {
      type: String || undefined,
    },
    codigosSelecionados: {
      type: Array as () => string[],
      default: () => [],
    },
    placeholder: {
      type: String,
      default: 'Selecione',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    filtrarApenasCstEntradas: {
      type: Boolean,
      default: false,
    },
    filtrarApenasCstSaidas: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:codigoSelecionado', 'update:codigosSelecionados', 'change'],
  setup(props, { emit }) {
    const { montaOpcoesComListaItemGenericoTexto } = useTelaBase();

    const state = reactive({
      // listaCstIpiSaidas: [] as IOptionString[],
      // listaCstIpiEntradas: [] as IOptionString[],
      listaCstIpi: [] as IOptionString[],
    });

    (async () => {
      // const listaCstIpiEntradas = await new ServicoCenarioFiscal().obterListaCstIpiEntradas();
      // state.listaCstIpiEntradas = montaOpcoesComListaItemGenericoTexto(listaCstIpiEntradas);

      // const listaCstIpiSaidas = await new ServicoCenarioFiscal().obterListaCstIpiSaidas();
      // state.listaCstIpiSaidas = montaOpcoesComListaItemGenericoTexto(listaCstIpiSaidas);
      const listaCstIpi = await new ServicoCenarioFiscal().obterListaCstIpi();
      state.listaCstIpi = montaOpcoesComListaItemGenericoTexto(listaCstIpi);
    })();

    function obterCstIpi():any {
      return props.codigoSelecionado;
    }

    const computedCodigoSelecionado = computed({
      get: () => obterCstIpi(),
      set: (val: string) => {
        emit('update:codigoSelecionado', val);
      },
    });

    const computedCodigosSelecionados = computed({
      get: () => props.codigosSelecionados,
      set: (val: string[]) => {
        emit('update:codigosSelecionados', val);
      },
    });

    function change() {
      emit('change', props.varios ? props.codigosSelecionados : props.codigoSelecionado);
    }

    return {
      props,
      state,
      computedCodigoSelecionado,
      computedCodigosSelecionados,
      change,
    };
  },
});
